export default {"src":"/_next/static/media/check_bold.56b172e9.svg","height":24,"width":24};